
/* tslint:disable */
export class Changes {
  path: string;
  value: string;
}

export class TagEvent {
  category: Category;
  action: string;
  label: string;
  events?: Events[];
  errorName?: string;
  messageEvent?: string;
  value?: string | number;
}

export class Category {
  module: string;
  type: string;
  position: string;
}

export class Events {
  name: string;
  value: string;
}

export class TagPath {
  family: string;
  subFamily: string;
  product: string;
}

export class TagPathProduct {
  tc: TagPath;
  payroll: TagPath;
  savingAccount: TagPath;
  revolvingCredit: TagPath;
  constructor(tcTagPath, payrollTagPath, savingAccountTagPath, revolvingCreditPath) {
    this.tc = tcTagPath;
    this.payroll = payrollTagPath;
    this.savingAccount = savingAccountTagPath;
    this.revolvingCredit = revolvingCreditPath;
  }
}

export class TagIdentifier {
  tc: string;
  payroll: string;
  savingAccount: string;
  revolvingCredit: string;
  constructor(tcId, payrollId, savingAccountId, revolvingCredit) {
    this.tc = tcId;
    this.payroll = payrollId;
    this.savingAccount = savingAccountId;
    this.revolvingCredit = revolvingCredit;
  }
}
